import React from 'react';

const Step6Export = ({ state, callbacks }) => {
  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      <div>
        <label className="block mb-2 text-xs font-medium text-dark-text-secondary tracking-tight">Anzahl der Frames</label>
        <input
          type="number"
          value={state.maxFrames}
          onChange={(e) => callbacks.setMaxFrames(parseInt(e.target.value) || 10)}
          min="1"
          max="1000"
          className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>

      <div>
        <div className="flex items-center gap-3 p-3 bg-white border border-dark-border rounded-lg">
          <input
            type="checkbox"
            id="exportYOLO"
            checked={state.exportYOLO}
            onChange={(e) => callbacks.setExportYOLO(e.target.checked)}
            className="flex-shrink-0 w-4 h-4 cursor-pointer accent-accent rounded transition-all duration-150"
          />
          <label htmlFor="exportYOLO" className="flex-1 text-sm text-dark-text font-medium cursor-pointer">
            YOLO-Format exportieren
          </label>
        </div>
      </div>
    </div>
  );
};

export default Step6Export;
